import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums';

// const StartSchedule = (param: any) =>
//     request({
//         url: ApiURL.Command.startSchedule,
//         method: RequestType.POST,
//         data: param,
//     });

// const PauseSchedule = (param: any) =>
//     request({
//         url: ApiURL.Command.pauseSchedule,
//         method: RequestType.POST,
//         data: param,
//     });

const RunSchedule = (param: any) =>
    request({
        url: ApiURL.Command.runSchedule,
        method: RequestType.POST,
        data: param,
    });

const StopSchedule = (param: any) =>
    request({
        url: ApiURL.Command.stopSchedule,
        method: RequestType.PUT,
        data: param,
    });

const ResumeSchedule = (param: any) =>
    request({
        url: ApiURL.Command.resumeSchedule,
        method: RequestType.PUT,
        data: param,
    });

const DeleteSchedule = (param: any) =>
    request({
        url: ApiURL.Command.deleteSchedule,
        method: RequestType.DELETE,
        data: param,
    });

const CreateSchedule = (param: any) =>
    request({
        url: ApiURL.Command.createSchedule,
        method: RequestType.POST,
        data: param,
    });

const UpdateSchedule = (param: any) =>
    request({
        url: ApiURL.Command.updateSchedule,
        method: RequestType.POST,
        data: param,
    });

const ScheduleServiceCommand = {
    // StartSchedule,
    // PauseSchedule,
    RunSchedule,
    StopSchedule,
    ResumeSchedule,
    DeleteSchedule,
    CreateSchedule,
    UpdateSchedule,
};

export default ScheduleServiceCommand;
